import { settingsConstants } from '../constants/settings.constants';

export function settings(state = {}, action) {
  switch (action.type) {
    case settingsConstants.UPDATE_REQUEST:
    case settingsConstants.FETCH_REQUEST:     
    case settingsConstants.GLOBAL_UPDATE_REQUEST:
    case settingsConstants.GLOBAL_FETCH_REQUEST:     
    case settingsConstants.WEBHOOK_CREATE_REQUEST:        
    case settingsConstants.WEBHOOK_FETCH_REQUEST:        
    case settingsConstants.WEBHOOK_UPDATE_REQUEST:        
    case settingsConstants.WEBHOOK_DELETE_REQUEST:        
      return {
        ...state,
        loading: true
      };    
    case settingsConstants.ACTION_SYNC_REQUEST:
      return {
        ...state,
        loadingSync: action.sync,
      };

    case settingsConstants.GLOBAL_UPDATE_SUCCESS:
    case settingsConstants.UPDATE_SUCCESS:
    return{
      ...state,
      item: action.settings,
      loading: false
    }

    case settingsConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.settings,
        loading: false
      };

    case settingsConstants.WEBHOOK_FETCH_SUCCESS:          
      return {
        ...state,
        webhooks: action.webhooks,
        loading: false
      };

    case settingsConstants.GLOBAL_FETCH_SUCCESS:      
      return {
        ...state,
        globalSettings: action.globalSettings,
        loading: false
      };

    case settingsConstants.ACTION_SYNC_SUCCESS:      
      return {
        ...state,        
        loadingSync: false
      };

    case settingsConstants.WEBHOOK_GET_SUCCESS:          
      return {
        ...state,        
        loadingSync: false,
        webhook: action.webhook,
      };

    case settingsConstants.UPDATE_FAILURE:
    case settingsConstants.FETCH_FAILURE:
    case settingsConstants.GLOBAL_FETCH_FAILURE:
    case settingsConstants.GLOBAL_UPDATE_FAILURE:
    case settingsConstants.ACTION_SYNC_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        loadingSync: false,        
      };   
    default:
      return state
  }
}
